import { ANALYSIS_PAGES, WIDGET_SIZES, WIDGET_TYPES } from 'components/global/ManageWidgets/widgetsUtils';

const sharedWidgets = [
	{
		id: 'numberOfOrders',
		type: WIDGET_TYPES.cards,
		size: WIDGET_SIZES.large,
		infoMessage: 'dashboard.numberOfOrders.infoMessage',
		sourcePage: ANALYSIS_PAGES.dashboard,
		isVisible: false
	},
	{
		id: 'overview',
		type: WIDGET_TYPES.cards,
		size: WIDGET_SIZES.large,
		sourcePage: ANALYSIS_PAGES.dashboard,
		isVisible: false
	},
	{
		id: 'currentOrders',
		type: WIDGET_TYPES.pie,
		size: WIDGET_SIZES.large,
		sourcePage: ANALYSIS_PAGES.dashboard,
		isVisible: false
	},
	{
		id: 'closedOrders',
		type: WIDGET_TYPES.pie,
		size: WIDGET_SIZES.medium,
		sourcePage: ANALYSIS_PAGES.dashboard,
		isVisible: false
	},
	{
		id: 'processingOrders',
		type: WIDGET_TYPES.pie,
		size: WIDGET_SIZES.medium,
		sourcePage: ANALYSIS_PAGES.dashboard,
		isVisible: false
	},
	{
		id: 'dashboard.orderDistribution',
		type: WIDGET_TYPES.column,
		size: WIDGET_SIZES.large,
		sourcePage: ANALYSIS_PAGES.dashboard,
		isVisible: false
	},
	{
		id: 'analysis.overview',
		type: WIDGET_TYPES.column,
		size: WIDGET_SIZES.large,
		sourcePage: ANALYSIS_PAGES.overview,
		isVisible: false
	},
	{
		id: 'analysis.pickupAging',
		type: WIDGET_TYPES.column,
		size: WIDGET_SIZES.medium,
		sourcePage: ANALYSIS_PAGES.overview,
		isVisible: false
	},
	{
		id: 'analysis.deliveryAging',
		type: WIDGET_TYPES.column,
		size: WIDGET_SIZES.medium,
		sourcePage: ANALYSIS_PAGES.overview,
		isVisible: false
	},
	{
		id: 'analysis.totalPendingByDC',
		type: WIDGET_TYPES.column,
		size: WIDGET_SIZES.large,
		sourcePage: ANALYSIS_PAGES.overview,
		isVisible: false
	},
	{
		id: 'analysis.pendingShipments',
		type: WIDGET_TYPES.table,
		size: WIDGET_SIZES.large,
		sourcePage: ANALYSIS_PAGES.overview,
		isVisible: false
	},
	{
		id: 'analysis.sla.delay',
		type: WIDGET_TYPES.cards,
		size: WIDGET_SIZES.large,
		sourcePage: ANALYSIS_PAGES.SLAPerformance,
		isVisible: false
	},
	{
		id: 'preparationSLAPerformance',
		type: WIDGET_TYPES.column,
		size: WIDGET_SIZES.large,
		sourcePage: ANALYSIS_PAGES.SLAPerformance,
		isVisible: false
	},
	{
		id: 'pickupSLAPerformance',
		type: WIDGET_TYPES.column,
		size: WIDGET_SIZES.large,
		sourcePage: ANALYSIS_PAGES.SLAPerformance,
		isVisible: false
	},
	{
		id: 'deliverySLAPerformance',
		type: WIDGET_TYPES.column,
		size: WIDGET_SIZES.large,
		sourcePage: ANALYSIS_PAGES.SLAPerformance,
		isVisible: false
	},
	{
		id: 'dcPerformance',
		type: WIDGET_TYPES.table,
		size: WIDGET_SIZES.large,
		sourcePage: ANALYSIS_PAGES.deliveryCompany,
		isVisible: false
	},
	{
		id: 'deliveryCompDistribution',
		type: WIDGET_TYPES.bar,
		size: WIDGET_SIZES.large,
		infoMessage: 'widgets.overview.deliveryCompDistribution.infoMessage',
		sourcePage: ANALYSIS_PAGES.deliveryCompany,
		isVisible: false
	},
	{
		id: 'shippingAccountingSummary',
		type: WIDGET_TYPES.cards,
		size: WIDGET_SIZES.large,
		sourcePage: ANALYSIS_PAGES.shippingAccounting,
		isVisible: false
	},
	{
		id: 'shippingFees',
		type: WIDGET_TYPES.pie,
		size: WIDGET_SIZES.large,
		sourcePage: ANALYSIS_PAGES.shippingAccounting,
		isVisible: false
	},
	{
		id: 'DCShippingFees',
		type: WIDGET_TYPES.pie,
		size: WIDGET_SIZES.medium,
		sourcePage: ANALYSIS_PAGES.shippingAccounting,
		isVisible: false
	},
	{
		id: 'OTOFees',
		type: WIDGET_TYPES.pie,
		size: WIDGET_SIZES.medium,
		sourcePage: ANALYSIS_PAGES.shippingAccounting,
		isVisible: false
	},
	{
		id: 'analysis.shippingAccounting.yourShippingPartners.codCollected',
		type: WIDGET_TYPES.pie,
		size: WIDGET_SIZES.medium,
		sourcePage: ANALYSIS_PAGES.shippingAccounting,
		isVisible: false
	},
	{
		id: 'orderValuesSummary',
		type: WIDGET_TYPES.cards,
		size: WIDGET_SIZES.large,
		sourcePage: ANALYSIS_PAGES.sales,
		isVisible: false
	},
	{
		id: 'shipmentPaymentType',
		type: WIDGET_TYPES.pie,
		size: WIDGET_SIZES.small,
		sourcePage: ANALYSIS_PAGES.sales,
		isVisible: false
	},
	{
		id: 'ordersByCity',
		type: WIDGET_TYPES.pie,
		size: WIDGET_SIZES.small,
		sourcePage: ANALYSIS_PAGES.sales,
		isVisible: false
	},
	{
		id: 'sales.numberOfOrders',
		type: WIDGET_TYPES.column,
		size: WIDGET_SIZES.large,
		sourcePage: ANALYSIS_PAGES.sales,
		isVisible: false
	},
	{
		id: 'avgBasketSize',
		type: WIDGET_TYPES.column,
		size: WIDGET_SIZES.large,
		sourcePage: ANALYSIS_PAGES.sales,
		isVisible: false
	},
	{
		id: 'oto-flex.orderValuesSummary',
		type: WIDGET_TYPES.cards,
		size: WIDGET_SIZES.large,
		infoMessage: 'widgets.oto-flex.orderValuesSummary.infoMessage',
		sourcePage: ANALYSIS_PAGES.otoFlex,
		isVisible: false
	},
	{
		id: 'oto-flex.numberOfOrders',
		type: WIDGET_TYPES.line,
		size: WIDGET_SIZES.large,
		infoMessage: 'widgets.oto-flex.numberOfOrders.infoMessage',
		sourcePage: ANALYSIS_PAGES.otoFlex,
		isVisible: false
	},
	{
		id: 'driverPerformance',
		type: WIDGET_TYPES.table,
		size: WIDGET_SIZES.large,
		sourcePage: ANALYSIS_PAGES.otoFlex,
		isVisible: false
	}
];

export const monitorViewRaw = {
	'/dashboard/monitor-view': sharedWidgets,
	'/analysis/monitor-view': sharedWidgets
};
